import { useUserContext } from '@/context'
import { useSelectedTeamMembers } from '@/hooks/useSelectedTeamMembers'
import type { Order } from '@skop-app/lib-domain/types'

export const useOrderAuthorization = (order?: Order) => {
  const { user, ownership, organizationScope } = useUserContext()
  const selectedOrganizationId = organizationScope.selectedOrganizationId
  const { data: teamMembers = [], isLoading: isLoadingTeamMembers } =
    useSelectedTeamMembers(selectedOrganizationId)

  if (!order?.id || !user?.id) {
    return { isAllowed: false, isLoading: false }
  }

  const isOrderBelongsToCurrentUser =
    order?.userID === user.id ||
    order?.managerID === user.id ||
    order?.toUser?.id === user.id ||
    order?.user?.id === user.id

  const memberOrganizationID =
    ownership?.organizationID ||
    teamMembers.find((member) => member.userID === user.id)?.organizationID

  const isTeamMemberOfOrderOrganization =
    memberOrganizationID &&
    [
      order?.organizationID,
      order?.shop?.organizationID,
      order?.toOrganizationID,
    ]
      .filter(Boolean)
      .includes(memberOrganizationID)

  const isAllowed =
    isTeamMemberOfOrderOrganization || isOrderBelongsToCurrentUser

  return {
    isAllowed,
    isLoading:
      !ownership?.organizationID &&
      !isOrderBelongsToCurrentUser &&
      Boolean(selectedOrganizationId) &&
      isLoadingTeamMembers,
  }
}
